import { render, staticRenderFns } from "./Weddings.vue?vue&type=template&id=2dcbfbee&scoped=true&lang=pug&"
import script from "./Weddings.vue?vue&type=script&lang=ts&"
export * from "./Weddings.vue?vue&type=script&lang=ts&"
import style0 from "./Weddings.vue?vue&type=style&index=0&id=2dcbfbee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbfbee",
  null
  
)

export default component.exports